<template>
  <section class="container">
    <form class="g-brd-around g-brd-gray-light-v4 g-pa-30 g-mb-30" novalidate="true">

      <div class="table-responsive">
  <table class="table table-bordered u-table--v2">
    <thead class="text-uppercase g-letter-spacing-1">
      <tr>
        <th class="g-font-weight-300 g-color-white" style="background-color:rgb(51,128,198)">Our Life Saving Rules</th>

      </tr>
    </thead>

   <tbody>
      <tr>

        <td class="align-left"><a href="https://www.dairyholdings.co.nz/media/b3cjrmm4/life-saving-rules1.pdf" target="_blank">Fit for Work</a></td>
        </tr>

         <tr>

        <td class="align-left"><a href="https://www.dairyholdings.co.nz/media/ooklq2mi/life-saving-rules2.pdf" target="_blank">Plan Your Work</a></td>
        </tr>

         <tr>
        <td class="align-left"><a href="https://www.dairyholdings.co.nz/media/u4kld0on/life-saving-rules3.pdf" target="_blank">No short cuts</a></td>
        </tr>
        <tr>
         <td class="align-left"><a href="https://www.dairyholdings.co.nz/media/5ljb3p4m/life-saving-rules4.pdf" target="_blank">Speak Up</a></td>
        </tr>
         <tr>
         <td class="align-left"><a href="https://www.dairyholdings.co.nz/media/r3qh5sdy/life-saving-rules5.pdf" target="_blank">Do not rush</a></td>
        </tr>
    </tbody>
  </table>
</div>

      <div v-if="errors.length" class="row g-pt-5">
        <div class="col-md-12">
          <!-- Danger Alert -->
          <div class="alert alert-danger" role="alert">
            <p>
              <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
            </p>
          </div>
          <!-- End Danger Alert -->
        </div>
      </div>

      <div class="form-group g-mb-25 g-pt-5">
        <label>Are you signing in or out?</label>
        <select v-model="visitorSignin.signInType" class="form-control rounded-0 mb-25" @change="signInTypeChanged">
          <option v-for="item in signinList" v-bind:key="item" :value="item">{{ item }}</option>
        </select>
      </div>

      <div :class="{ 'has-danger': !validation.farmId.value && validation.farmId.hasTouched }"
           class="form-group g-mb-25">
        <label>{{
            visitorSignin.signInType === 'IN' ? 'Which farm are you visiting?' : 'Which farm did you visit?'
          }}</label>
        <Farms @farmChanged="farmChanged"></Farms>
        <div v-if="farmManager.farmOperator !== undefined && farmManager.farmOperator !== ''">
          <small>Farm operator: {{ farmManager.farmOperator }}<br>
            Mobile number: {{ farmManager.mobileNumber }}</small>
        </div>
        <div
            v-if="!validation.farmId.value && validation.farmId.hasTouched"
            class="form-control-feedback"
        >{{ validation.farmId.required.errorMessage }}
        </div>

      </div>

      <div v-if="visitorSignin.signInType === 'IN'">
        <div :class="{ 'has-danger': !validation.contractorName.value && validation.contractorName.hasTouched }"
             class="form-group g-mb-25">
          <label>Who do you work for?</label>
          <contractor-list-input v-bind:farmId="visitorSignin.farmId" v-bind:init-contractor="visitorSignin.selectedContractor"
                                 @contractorSelected="contractorSelected"></contractor-list-input>
          <div
              v-if="!validation.contractorName.value && validation.contractorName.hasTouched"
              class="form-control-feedback"
          >{{ validation.contractorName.required.errorMessage }}
          </div>
        </div>

        <div v-if="isSignInFieldsReady">
          <div :class="{ 'has-danger': !validation.visitorName.value && validation.visitorName.hasTouched }"
               class="form-group g-mb-25">
            <label>Your name</label>
            <input
                v-model="visitorSignin.visitorName"
                class="form-control form-control-md rounded-0"
                type="text"
                @blur="visitorNameBlur"
            />
            <div
                v-if="!validation.visitorName.value && validation.visitorName.hasTouched"
                class="form-control-feedback"
            >{{ validation.visitorName.required.errorMessage }}
            </div>
          </div>

          <div
              :class="{ 'has-danger': !validation.visitorMobileNumber.value && validation.visitorMobileNumber.hasTouched }"
              class="form-group g-mb-25">
            <label>Your mobile number</label>
            <input
                v-model="visitorSignin.visitorMobileNumber"
                class="form-control form-control-md rounded-0"
                type="text"
                @blur="visitorMobileNumberBlur"
            />
            <div
                v-if="!validation.visitorMobileNumber.required.value && validation.visitorMobileNumber.hasTouched"
                class="form-control-feedback"
            >{{ validation.visitorMobileNumber.required.errorMessage }}
            </div>
            <div
                v-if="!validation.visitorMobileNumber.max.value && validation.visitorMobileNumber.hasTouched"
                class="form-control-feedback"
            >{{ validation.visitorMobileNumber.max.errorMessage }}
            </div>
          </div>
<!--
          <div>
            <div class="table-responsive d-none d-md-block">
              <table class="table table-bordered">
                <thead>
                <tr style="background-color:lightgray;">
                  <th class="text-center" colspan="4">
                    <p><b>DAIRY HOLDINGS LTD FARM SAFETY RULES</b></p>
                    <p><b>The following set of rules are in place for your own safety as well as other around you.<br/>
                      All CONTRACTORS and VISITORS must ensure they comply.</b></p>
                  </th>

                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry1.png"/></td>
                  <td class="align-middle">Entry and exit to the farm by the Yard entrance only.</td>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry2.png"/></td>
                  <td class="align-middle">Entry to other locations than your designated work location is STRICTLY
                    PROHIBITED
                  </td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry3.png"/></td>
                  <td class="align-middle">This is a drug and alcohol-free property.</td>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry4.png"/></td>
                  <td class="align-middle">No Smoking/ Smoking permitted in designated areas only.</td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry5.png"/></td>
                  <td class="align-middle" colspan="3">This farm is an active work site. Please be vigilant of
                    livestock, people, vehicles and machinery.
                  </td>

                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry6.png"/></td>
                  <td class="align-middle">BEWARE of overhead power lines as marked on Farm Maps.</td>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry7.png"/></td>
                  <td class="align-middle">No children or unauthorised persons allowed on site</td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry8.jpg"/></td>
                  <td class="align-middle">Please drive safely to suit the conditions and adhere to any displayed speed
                    limits. Farm max speed limit is 30km.
                  </td>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry9.png"/></td>
                  <td class="align-middle">Any NEW HAZARDS must be notified to Farm Management ASAP.</td>
                </tr>
                <tr style="background-color:lightgray;">
                  <td class="align-middle" colspan="2">


                    <p><b> PERSONAL PROTECTIVE EQUIPMENT REQUIRED</b></p></td>
                  <td class="align-middle" colspan="2"><p><b>DHL H&amp;S MANAGEMENT CONTACT DETAILS</b><br> Please phone
                    if any assistance is required</p></td>

                </tr>
                <tr>
                  <td class="align-middle" colspan="2">
                    <div class="row">
                      <div class="col-md-6">
                        <img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry10.png"/>
                        <img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry11.png"/>
                      </div>
                      <div class="col-md-6 align-middle text-danger">
                        <p><b> This protective equipment must be always be worn when on a DHL property.</b></p>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle text-center" colspan="2"><h3>Jane Fowles<br> 027 942 1500</h3></td>

                </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive-sm d-block d-md-none">
              <table class="table table-bordered">
                <thead>
                <tr style="background-color:lightgray;">
                  <th class="text-center" colspan="2">
                    <p><b>DAIRY HOLDINGS LTD FARM SAFETY RULES</b></p>
                    <p><b>The following set of rules are in place for your own safety as well as other around you.<br/>
                      All CONTRACTORS and VISITORS must ensure they comply.</b></p>
                  </th>

                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry1.png"/></td>
                  <td class="align-middle">Entry and exit to the farm by the Yard entrance only.</td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry2.png"/></td>
                  <td class="align-middle">Entry to other locations than your designated work location is STRICTLY
                    PROHIBITED
                  </td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry3.png"/></td>
                  <td class="align-middle">This is a drug and alcohol-free property.</td>

                </tr>
                <tr>

                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry4.png"/></td>
                  <td class="align-middle">No Smoking/ Smoking permitted in designated areas only.</td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry5.png"/></td>
                  <td class="align-middle">This farm is an active work site. Please be vigilant of livestock, people,
                    vehicles and machinery.
                  </td>

                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry6.png"/></td>
                  <td class="align-middle">BEWARE of overhead power lines as marked on Farm Maps.</td>

                </tr>
                <tr>

                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry7.png"/></td>
                  <td class="align-middle">No children or unauthorised persons allowed on site</td>
                </tr>
                <tr>
                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry8.jpg"/></td>
                  <td class="align-middle">Please drive safely to suit the conditions and adhere to any displayed speed
                    limits. Farm max speed limit is 30km.
                  </td>

                </tr>
                <tr>

                  <td><img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry9.png"/></td>
                  <td class="align-middle">Any NEW HAZARDS must be notified to Farm Management ASAP.</td>
                </tr>
                <tr style="background-color:lightgray;">
                  <td class="align-middle" colspan="2">


                    <p><b> PERSONAL PROTECTIVE EQUIPMENT REQUIRED</b></p></td>

                </tr>

                <tr>
                  <td class="align-middle" colspan="2">
                    <div class="row">
                      <div class="col-md-6">
                        <img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry10.png"/>
                        <img alt="registry1" class="img-fluid" src="/media/website/hsapp/registry11.png"/>
                      </div>
                      <div class="col-md-6 align-middle text-danger">
                        <p><b> This protective equipment must be always be worn when on a DHL property.</b></p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="background-color:lightgray;">
                  <td class="align-middle" colspan="2"><p><b>DHL H&amp;S MANAGEMENT CONTACT DETAILS</b><br> Please phone
                    if any assistance is required</p></td>

                </tr>
                <tr>
                  <td class="align-middle text-center" colspan="2"><h3>Jane Fowles<br> 027 942 1500</h3></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div> -->

          <div class="row g-pt-10">
            <div class="col-md-12">
              <h3 class="h3 text-uppercase">Please review farm map below for hazards:</h3>

              <!-- Table Bordered -->
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>Hazard</th>
                    <th>Hazard Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="hazard in displayedHazards" v-bind:key="hazard.eventDescription">

                    <td>
                      <span v-if="hazard.permanentHazardInd" class="alert-danger">
                        {{ hazard.eventDescription }}
                      </span>
                      <span v-else>
                        {{ hazard.eventDescription }}
                      </span>

                      <div class="g-pd-5">
                        <button class="btn btn-md u-btn-primary rounded-0 g-mt-5" v-if="hazard.safetyPlanId > 0" @click.prevent="openSafetyPlan(hazard.safetyPlanId)">Read project safety plan</button>
                        <p v-if="hazard.safetyPlanId > 0"><em>Last Updated {{ getLastUpdatedForSafetyPlan(hazard.safetyPlanId) }}</em></p>
                      </div>
                    </td>
                    <td>{{ hazard.eventDate }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row g-pt-5" v-if="hazardMap !== undefined && hazardMap.length > 0">
            <div class="col-md-12">
                 <iframe :src="hazardMap" style="width: 100%; height: 100vh" v-if="isPDF"></iframe>
                 <img :src="hazardMap" class="img-fluid" v-else>
            </div>
          </div>


          <div class="row g-pt-15">
            <div class="col-md-12">
              <p class="text-danger">Please be aware of other people currently on the farm</p>
              <!-- Table Bordered -->
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Signin Time</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="farmVisitor in farmVisitors" v-bind:key="farmVisitor.visitorName">

                    <td>{{ farmVisitor.visitorName }}</td>
                    <td>{{ farmVisitor.contractorName }}</td>
                    <td>{{ toTime(farmVisitor.signInDate) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


      <div class="row">
        <div class="col-md-12">
            <div :class="{ 'has-danger': !validation.readRegistry.value && validation.readRegistry.hasTouched }"
                class="form-group g-mb-25 text-left text-danger">
              <div class="form-check custom-control">
                <label>
                  <input v-model="visitorSignin.readRegistry" class="form-check-input mr-1" type="checkbox"
                        @change="readRegistryChanged"/>
                  I have read and understood the Dairy Holdings Hazard Registry<br />
 I acknowledge that by signing in, I may be subject to random drug testing under Dairy Holdings policy.<br />
 I have read and understood any farm-specific hazards
                </label>

              </div>
            </div>
        </div>
      </div>



          <div class="row">
            <div class="col-md-12">
              <div class="form-group g-mb-25 text-left">
                <div class="form-check custom-control">
                  <label>
                    <input v-model="rememberMyDetails" class="form-check-input mr-1" type="checkbox"/>
                    Remember my signin details
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="isSignOutFieldsReady"
             :class="{ 'has-danger': !validation.signOutId.value && validation.signOutId.hasTouched }"
             class="form-group g-mb-25">
          <label>Your name</label>
          <select v-model="visitorSignin.id" class="form-control rounded-0 mb-25" @change="signOutIdChanged">
            <option v-for="item in farmVisitors" v-bind:key="item.id" :value="item.id">{{ item.visitorName }}</option>
          </select>
          <div
              v-if="!validation.signOutId.value && validation.signOutId.hasTouched"
              class="form-control-feedback"
          >{{ validation.signOutId.required.errorMessage }}
          </div>
        </div>

        <div v-if="isSignOutFieldsReady"
             :class="{ 'has-danger': !validation.hazardDescription.value && validation.hazardDescription.hasTouched }"
             class="form-group g-mb-25">
          <label>If you have noticed a hazard on farm, please report it below</label>

          <textarea
              v-model="visitorSignin.hazardDescription"
              class="form-control rounded-0 form-control-md"
              rows="3"
              @blur="hazardDescriptionBlur"
          ></textarea>
          <div
              v-if="!validation.hazardDescription.value && validation.hazardDescription.hasTouched"
              class="form-control-feedback"
          >{{ validation.hazardDescription.max.errorMessage }}
          </div>
        </div>
      </div>

      <button
          v-if="isSignInFieldsReady"
          :disabled="isSaving"
          class="btn btn-md u-btn-primary rounded-0 g-mt-5"
          type="button"
          @click="validateForm"
      >{{ isSaving ? 'Signing in...' : 'Sign in' }}
      </button>

      <button
          v-if="isSignOutFieldsReady"
          :disabled="isSaving"
          class="btn btn-md u-btn-primary rounded-0 g-mt-5"
          type="button"
          @click="validateForm"
      >{{ isSaving ? 'Signing out...' : 'Sign out' }}
      </button>

      <div v-if="errors.length" class="row pt-2">
        <div class="col-md-12">
          <!-- Danger Alert -->
          <div class="alert alert-danger" role="alert">
            <p>
              <b>Please correct the errors above before saving.</b>

            </p>
          </div>
          <!-- End Danger Alert -->
        </div>
      </div>

    </form>

      <safety-plan-modal :safetyPlanId="selectedSafetyPlan" :show="showSafetyPlanModal" @close="closeSafetyPlanModal"></safety-plan-modal>
    </section>
</template>

<script>
import * as Sentry from "@sentry/vue";
import AppConfig from '../appconfig';
import {onMounted, ref} from "vue";
import Farms from "../components/visitorSignIns/Farms.vue";
import ContractorListInput from "../components/visitorSignIns/contractorListInput.vue";
import VisitorSignInService from "../services/visitorsigninservice";
import ValidationService from "../services/validationservice";
import StaffService from "../services/staffservice";
import UserService from "../services/userservice";
import SafetyPlanService from "../services/safetyplanservice";
import DateUtils from "../utils/dateutils";
import Store from "../store/index";
import SafetyPlanModal from '../components/visitorSignIns/SafetyPlanModal.vue';

export default {
  name: "App",
  components: {
    Farms,
    ContractorListInput,
    SafetyPlanModal
  },
  setup() {
    const visitorSignin = ref({
      id: null,
      farmId: null,
      contractorId: null,
      contractorName: null,
      hazardDescription: null,
      visitorName: null,
      visitorMobileNumber: null,
      viewedHazardMap: 'N',
      contractorType: null,
      signInType: null,
      readHazards: false,
      readRegistry: false,
      readDrugTest: false,
      selectedContractor: null
    });

    const signinList = ref(['IN', 'OUT']);
    const visitorSignInService = VisitorSignInService;
    const validationService = ValidationService;
    const userService = UserService;
    const staffService = StaffService;
    const safetyPlanService = SafetyPlanService;
    const dateUtils = DateUtils;
    const hazards = ref([]);
    const farmVisitors = ref([]);
    const contractors = ref([]);
    const currentFarm = ref({farmShortname: '', id: ''});
    const farmManager = ref({mobileNumber: '', farmOperator: ''});
    const hazardMap = ref('');
    const isLoggedIn = ref(false);
    const rememberMyDetails = ref(false);
    const store = Store;
    const clickedSafetyPlans = ref([]);
    const safetyPlans = ref([]);
    const requiresToClickSafetyPlans = ref(false);
    const teamChecklist = ref(['Were Drug and Alcohol Free.', 'Protected themselves when dealing with stock.', 'Used the right vehicle, the right way with the right person.', 'Stayed away from machinery that they did not need to be around', 'I did not observe any of the farm team today']);
    const selectedTeamChecklist = ref([]);
    const showSafetyPlanModal = ref(false);
    const selectedSafetyPlan = ref(null);

    const isRememberMyDetailsAvailable = () => {
      return store.signInName && store.signInMobileNumber && store.signInContractor;
    }

    const loadMyDetailsFromStore = () => {
      visitorSignin.value.visitorName = store.signInName;
      visitorSignin.value.visitorMobileNumber = store.signInMobileNumber;
      visitorSignin.value.selectedContractor = store.signInContractor;
      visitorSignin.value.contractorId = store.signInContractor.contractorId;
      visitorSignin.value.contractorName = store.signInContractor.contractorDescription;
      visitorSignin.value.contractorType = store.signInContractor.contractorType;

      if (store.signInContractor.contractorType == null) {
        visitorSignin.value.contractorName = store.signInContractor.contractorOther;
      }

      rememberMyDetails.value = true;
    }

    const openSafetyPlan = (id) => {
      if (!clickedSafetyPlans.value.includes(id)) {
        clickedSafetyPlans.value.push(id);
      }

      selectedSafetyPlan.value = id;
      showSafetyPlanModal.value = true;
    }

    const closeSafetyPlanModal = () => {
      showSafetyPlanModal.value = false;
    }

    onMounted(async () => {
      visitorSignin.value.signInType = 'IN';

      //if there is a name/mobile number/contractorName in local storage, use this
      if (isRememberMyDetailsAvailable()) {
        loadMyDetailsFromStore();
      }

      //if the user is logged in, load the user profile
      isLoggedIn.value = await userService.isUserLoggedIn();
      if (isLoggedIn.value) {
        let userDetails = await userService.getUser();

        if (userDetails) {
          //get the staff listing details
          let staffDetails = await staffService.fetchSingleReadOnly(userDetails.staffId);

          if (staffDetails) {
            visitorSignin.value.visitorName = userDetails.fullName;
            visitorSignin.value.visitorMobileNumber = staffDetails.mobileNumber;
          }
        }
      }
    });

    return {
      visitorSignin,
      signinList,
      visitorSignInService,
      validationService,
      safetyPlanService,
      hazards,
      farmVisitors,
      contractors,
      currentFarm,
      farmManager,
      hazardMap,
      dateUtils,
      isLoggedIn,
      rememberMyDetails,
      store,
      openSafetyPlan,
      clickedSafetyPlans,
      requiresToClickSafetyPlans,
      safetyPlans,
      teamChecklist,
      selectedTeamChecklist,
      showSafetyPlanModal,
      selectedSafetyPlan,
      closeSafetyPlanModal
    };
  },
  data() {
    return {
      errors: [],
      isSaving: false,
      validation: {
        farmId: {
          required: {
            errorMessage: "Farm is required"
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            // { field: 'ethnicity', value: 'Other' },
          ]
        },
        contractorName: {
          required: {
            errorMessage: "Contractor is required"
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'IN'},
          ]
        },
        visitorName: {
          required: {
            errorMessage: "Visitor Name is required"
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'IN'},
          ]
        },
        visitorMobileNumber: {
          required: {
            errorMessage: "Visitor Mobile Number  is required"
          },
          max: {
            length: 5000,
            errorMessage: "Mobile Number must not be more than 5000 characters",
            value: true
          },
          numeric: {
            errorMessage: "Mobile Number must be numeric",
            value: true
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'IN'},
          ]
        },
        readRegistry: {
          matchValue: {
            errorMessage: "Please read and tick that you have read the Dairy Holdings Hazard Registry, subject to a random drug test and have read the farm-specific hazards",
            equals: true
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'IN'},
          ]
        },
        signOutId: {
          required: {
            errorMessage: "Please select yourself from the list to sign out"
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'OUT'},
          ]
        },
        hazardDescription: {

          max: {
            length: 5000,
            errorMessage: "Reporting a hazard must not be more than 5000 characters",
            value: true
          },
          value: false, //force to be true because we are defaulting to today
          hasTouched: false,
          relationships: [
            {field: 'signInType', value: 'OUT'},
          ]
        },
      }
    };
  },
  computed: {
    displayedHazards: function () {
      return this.hazards.filter(h => h != null);
    },
    isSignInFieldsReady: function () {
      return this.visitorSignin.signInType === 'IN' && this.visitorSignin.farmId != null && this.visitorSignin.contractorName != null;
    },
    isSignOutFieldsReady: function () {
      return this.visitorSignin.signInType === 'OUT' && this.visitorSignin.farmId != null;
    },
    isPDF: function() {
      return this.hazardMap != null && this.hazardMap.length > 0 && this.hazardMap.toLocaleLowerCase().indexOf('.pdf') > -1;
    },
  },
  methods: {
    validateForm(e) {
      this.errors = [];

      this.validationService.validateProperty(this.validation, this.visitorSignin, 'contractorName', this.visitorSignin.contractorName);
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'visitorName', this.visitorSignin.visitorName);
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'visitorMobileNumber', this.visitorSignin.visitorMobileNumber);
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'readRegistry', this.visitorSignin.readRegistry);

      this.validationService.validateProperty(this.validation, this.visitorSignin, 'signOutId', this.visitorSignin.id);
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'farmId', this.visitorSignin.farmId);
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'hazardDescription', this.visitorSignin.hazardDescription);

      this.errors.push(...this.validationService.validate(this.validation));

      //if the user is signing in and they need to click a safety plan, ensure they have done so
      if (this.visitorSignin.signInType === 'IN' &&
          this.requiresToClickSafetyPlans && this.clickedSafetyPlans.length != this.safetyPlans.length) {
        this.errors.push('Please read the project safety plan in the hazard list below');
      }

      if (!this.errors.length) {
        this.save();
      }

      e.preventDefault();
    },
    signInTypeChanged() {
    },
    async contractorSelected(contractor) {
      this.visitorSignin.selectedContractor = contractor;
      this.visitorSignin.contractorId = contractor.contractorId;
      this.visitorSignin.contractorName = contractor.contractorDescription;
      if (contractor.contractorType == null) {
        this.visitorSignin.contractorName = contractor.contractorOther;
      }
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'contractorName', this.visitorSignin.contractorName);

      await this.loadSafetyPlans();
    },
    visitorNameBlur: function () {
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'visitorName', this.visitorSignin.visitorName);
    },
    visitorMobileNumberBlur: function () {
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'visitorMobileNumber', this.visitorSignin.visitorMobileNumber);
    },
    readRegistryChanged: function () {
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'readRegistry', this.visitorSignin.readRegistry);
    },

    signOutIdChanged: function () {
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'signOutId', this.visitorSignin.id);
    },
    hazardMapClicked: function () {
      this.visitorSignin.viewedHazardMap = 'Y';
    },
    hazardDescriptionBlur: function () {
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'hazardDescription', this.visitorSignin.hazardDescription);
    },
    async farmChanged(farm) {
      this.visitorSignin.farmId = farm.id;
      this.currentFarm = farm;
      this.validationService.validateProperty(this.validation, this.visitorSignin, 'farmId', this.visitorSignin.farmId);
      await this.loadHazards();
      await this.loadFarmVisitors();
      await this.loadFarmManager();
      await this.loadHazardMap();
      await this.loadSafetyPlans();
    },
    toDate(dateAsText) {
      if (
          !dateAsText ||
          dateAsText === ""
      )
        return "";

      const d0 = new Date(dateAsText);
      return this.dateUtils.formatDate(d0);

    },
    toTime(dateAsText) {
      if (
          !dateAsText ||
          dateAsText === ""
      )
        return "";

      const d0 = new Date(dateAsText);
      return this.dateUtils.formatDateTime(d0);

    },
    prepareForSave() {
      return Object.assign(
          {},
          {
            farmId: this.visitorSignin.farmId,
            contractorId: this.visitorSignin.contractorId,
            contractorName: this.visitorSignin.contractorName,
            visitorName: this.visitorSignin.visitorName,
            visitorMobileNumber: this.visitorSignin.visitorMobileNumber,
            viewedHazardMap: this.visitorSignin.viewedHazardMap,
            contractorType: this.visitorSignin.contractorType,
            hazardDescription: this.visitorSignin.hazardDescription,
            teamChecklist: this.selectedTeamChecklist.join(','),
          }
      );
    },
    async loadHazards() {
      let results = await this.visitorSignInService.fetchHazards(this.visitorSignin.farmId);
      this.hazards.splice(0);
      results.forEach(h => this.hazards.push(Object.assign({}, {
        eventDescription: h.eventDescription,
        eventDate: this.toDate(h.eventDate),
        permanentHazardInd: h.permanentHazardInd,
        safetyPlanId: h.safetyPlanId
      })));
    },
    async loadFarmVisitors() {
      this.farmVisitors = await this.visitorSignInService.fetchSignins(this.visitorSignin.farmId);
    },
    async loadFarmManager() {
      let farmManager = await this.visitorSignInService.fetchFarmManager(this.visitorSignin.farmId);
      this.farmManager = Object.assign({}, farmManager);
    },
    async loadHazardMap() {
      this.hazardMap = await this.visitorSignInService.fetchHazardMap(this.visitorSignin.farmId);
    },
    async loadSafetyPlans() {
      let results = await this.safetyPlanService.fetchSafetyPlans(this.visitorSignin.farmId);
      this.safetyPlans.splice(0);
      results.forEach(h => this.safetyPlans.push(h));

      // Everyone should read the safety plans if they are available.
      this.requiresToClickSafetyPlans = true;
    },
    getLastUpdatedForSafetyPlan(safetyPlanId) {
      let safetyPlan = this.safetyPlans.find(s => s.id === safetyPlanId);
      if (safetyPlan) {
        return this.toTime(safetyPlan.timeStart);
      }
      return '';
    },
    async save() {
      this.isSaving = true;

      try {

        let model = this.prepareForSave();

        if (this.visitorSignin.signInType === 'IN') {

          //If the user wants to remember the details, store these in session
          if (this.rememberMyDetails) {
            this.store.signInName = model.visitorName;
            this.store.signInMobileNumber = model.visitorMobileNumber;
            this.store.signInContractor = this.visitorSignin.selectedContractor;
          } else {
            this.store.signInName = '';
            this.store.signInMobileNumber = '';
            this.store.signInContractor = '';
          }

          await this.visitorSignInService.signIn(model);
          this.isSaving = false;

          if (!AppConfig.development) {
            window.location = '/farm-visitor-sign-in/thank-you-sign-in';
          }
        } else {
          model.id = this.visitorSignin.id;

          await this.visitorSignInService.signOut(model);
          this.isSaving = false;

          if (!AppConfig.development) {
            window.location = '/farm-visitor-sign-in/thank-you-sign-out';
          }
        }
      } catch (e) {
        Sentry.captureException(e);
        this.isSaving = false;
      }
    }
  }
};
</script>

